<template>
  <li
    v-if="item.condition"
    class="anchor-nav__item self-stretch py-3 transition-all cursor-pointer
    text-EXPONDO-grey-60 text-sm relative hover:text-EXPONDO-black mt-auto"
    :class="{
      'anchor-nav__item--active text-EXPONDO-black': isItemActive
    }"
    @click="scrollToAnchor"
  >
    <span>{{ item.text }}</span>
  </li>
</template>

<script lang="ts">

import { PDP_NAV_ANCHORS } from '~~/constants/pdpNavAnchors';

import type { ProductAnchorNavItem } from '~~/types/product/AnchorNav';
import { scrollToSection } from '~~/helpers/scroll/scrollToSection';

export default defineComponent({
  name: 'ProductAnchorNavItem',
  props: {
    item: {
      type: Object as PropType<ProductAnchorNavItem>,
      required: true,
    },
  },
  setup (props) {

    const { activeSection, stickyAnchorNavHeight } = useAnchorNavigationStore();
    // needed addidional px to enter section and make it active in intersector observer
    const additionalPxToEnterSection = 1;

    const scrollToAnchor = () => {

      scrollToSection(`#${props.item.sectionId}`, -stickyAnchorNavHeight.value + additionalPxToEnterSection);
    
    };
    const isItemActive = computed(() => activeSection.value === props.item.sectionId);

    return {
      PDP_NAV_ANCHORS,
      scrollToAnchor,
      isItemActive,
    };
  
  },
});

</script>

<style lang="scss" scoped>
.anchor-nav__item {
  &::after {
    content: '';

    @apply absolute left-0 -bottom-0.5 w-full h-0.5 bg-transparent transition-all;
  }

  &--active {
    &::after {
      @apply bg-EXPONDO-secondary;
    }
  }
}
</style>
